/* eslint-disable no-useless-escape */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON } from '../../global/Constants';
import './set-new-password.css';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';
import Loader from '../common/loader/Loader';
import AuthService from '../../providers/AuthService';

const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

class SetNewPasswordPage extends Component {

    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            errorMsg: '',
            loading: false,
            setPasswordShown1: false,
            setPasswordShown2: false,
            fields: {
                password1: "",
                password2: ""
            }
        }
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidMount() {
        const session = AuthService.getSession();
        if (session) {
            document.getElementById("login").disabled = true;
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || (typeof value === 'undefined')) {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields })
        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        document.getElementById("login").disabled = (password1.length < 8 || password2.length < 8);

        let message = '';
        if (!strongRegex.test(password1) && password1.length < 21) {
            message = 'Password must be 8 to 20 character, It includes contain at least 1 lowercase, 1 uppercase, 1 numeric and 1 Special characters.'
            document.getElementById("login").disabled = true;
        } else {
            message = '';
            document.getElementById("login").enabled = false;
        }

        this.setState({
            errorMsg: message
        });

        // if (8 > password1.length || password1.length > 20) {
        //     this.setState({
        //         errorMsg: "Password must be 8 to 20 character"
        //     });
        // } else {
        //     this.setState({
        //         errorMsg: ""
        //     });
        // }
    }

    _performChangePassword = (e) => {
        this.setState({ loading: true });
        e.preventDefault();

        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        var body = JSON.stringify({
            newPassword: password1,
            confirmPassword: password2,
        });

        try {
            ApiServices.changePassword(body)
                .then(response => {
                    this.setState({ loading: false });
                    var status = response.success;
                    if (status) {
                        this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ loading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ loading: false, errorMsg: error });
        }
    }

    _handleSignIn = (e) => {
        e.preventDefault();
        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        if (password1 === password2) {
            this._performChangePassword(e);
        } else {
            this.setState({
                errorMsg: "Passwords do not match"
            });
        }
    }

    _togglePasswordVisiblity1 = () => {
        this.setState({ setPasswordShown1: !this.state.setPasswordShown1 });
    };

    _togglePasswordVisiblity2 = () => {
        this.setState({ setPasswordShown2: !this.state.setPasswordShown2 });
    };

    render() {
        const { setPasswordShown1, setPasswordShown2, errorMsg, loading } = this.state;
        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        return (
            <div className="sign-page input-dh">
                <div className="row mx-auto">
                    <div className="col-md-6 col-12 homeimg pr-5">
                        <img src="../assets/images/login-side-image.jpg" className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-6 col-12 pl-md-0 pr-md-5">
                        <div className="row">
                            <div className="col-12 signin-max-489">
                                <div className="logo">
                                    <i class="customic ic-back-button mb-3" onClick={() => this.goBack()}></i><br />

                                    <img src="../assets/images/logo.png" className="img-fluid" alt="" />
                                </div>

                                <h5>Set New Password</h5>
                                <form action="">
                                    <div className="form-group pass-hide-show">
                                        <input type={setPasswordShown1 ? "text" : "password"} className="form-control" placeholder="Enter New Password" onChange={this._handleValueChange.bind(this, "password1")} value={password1} />
                                        <i className={setPasswordShown1 ? "customic ic-eye" : "customic ic-eye-hide"} onClick={this._togglePasswordVisiblity1} ></i>
                                    </div>
                                    <div className="form-group pass-hide-show">
                                        <input type={setPasswordShown2 ? "text" : "password"} className="form-control" placeholder="Re-enter New Password" onChange={this._handleValueChange.bind(this, "password2")} value={password2} />
                                        <i className={setPasswordShown2 ? "customic ic-eye" : "customic ic-eye-hide"} onClick={this._togglePasswordVisiblity2} ></i>
                                        <span className={(errorMsg.length > 0) ? "error-msg" : "d-none error-msg"}>{errorMsg}</span>
                                    </div>
                                    <button id="login" className="btn btn-primary w-100 mb-2" onClick={this._handleSignIn}>LOGIN</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <Loader /> : null}
            </div>
        )
    }
}

export default withRouter(SetNewPasswordPage)